import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Pro(){
    const settings = {
        arrows: true,
        dots: true,
        mobileFirst: true,
        swipeToSlide: true,
        touchMove: true,
        cssEase: "ease-out",
        adaptiveHeight: true,
    }

    return(
        <Slider {...settings}>
            <article>
                <h3 className="mt-2em">Développeur web indépendant</h3>
                <p className="text-blue">Avril 2026 – Actuellement</p>
                <p>Auto-entrepreneur, Montpellier</p>
            </article>
            <article>
                <h3 className="mt-2em">Assistant Administratif</h3>
                <p className="text-blue">Novembre 2024 – Mars 2026</p>
                <p>Montpellier Dépannage, Montpellier</p>
            </article>
            <article>
                <h3 className="mt-2em">Responsable de boutique</h3>
                <p className="text-blue">Août 2023 – Novembre 2024</p>
                <p>Drôle de Pain, boulangerie artisanale, Montpellier</p>
            </article>
            <article>
                <h3 className="mt-2em">Stage Développement Web</h3>
                <p className="text-blue">Juin 2023 – Août 2023</p>
                <p>ASAP Studio, Montpellier</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Utilisation de JavaScript Vanilla et PHP, sur des projets WordPress</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Mise en place de composants pour un projet interne en Nuxt/Vue.js</p>
            </article>
            <article>
                <h3 className="mt-2em">Formateur Junior à distance</h3>
                <p className="text-blue">Octobre 2021 – Juin 2022</p>
                <p>ATE Formation, Montpellier</p>
                <div className="flex">
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Français Langue Étrangère (FLE)</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Anglais</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Espagnol</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Pack Office / Microsoft 365</p>
                </div>
            </article>
            <article>
                <h3 className="mt-2em">Vendeur en boulangerie</h3>
                <p className="text-blue">Janvier 2019 – Septembre 2021</p>
                <p>Drôle de Pain, boulangerie artisanale, Montpellier</p>
            </article>
            <article>
                <h3 className="mt-2em">Employé polyvalent de restauration</h3>
                <p className="text-blue">Janvier – Juillet 2018</p>
                <p>La Cave du 164, Hôtel Ibis Montpellier Sud, Montpellier</p>
            </article>
        </Slider>
    )
}

export default Pro
